/**
 * IM-004: Wraps Commerce SDK `useProduct` and injects `inventoryIds` from the warehouse cookie.
 */

import {useMemo} from 'react';

import {useProduct as useBaseProduct} from '@salesforce/commerce-sdk-react';

import {mergeCommerceSdkProductOptionsWithInventoryIds} from '../utils/merge-commerce-sdk-product-options';
import {useShopperInventoryIds} from './use-shopper-inventory-ids';

export function useProduct(options, queryOptions) {
  const inventoryIds = useShopperInventoryIds();
  const mergedOptions = useMemo(
    () => mergeCommerceSdkProductOptionsWithInventoryIds(options, inventoryIds),
    [options, inventoryIds]
  );

  return useBaseProduct(mergedOptions, queryOptions);
}

export default useProduct;
